var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { EventDispatcher } from "../event";
import { uuidv4 } from "../util";
import { openFileBrowser } from "./FileBrowser";
import { NeoPdfDocument } from "./NeoPdfDocument";
let _pdf_manager = undefined;
export var PdfManagerEventName;
(function (PdfManagerEventName) {
    PdfManagerEventName["ON_PDF_LOADED"] = "on_pdf_loaded";
})(PdfManagerEventName || (PdfManagerEventName = {}));
export class NeoPdfManager {
    constructor() {
        this._pdfs = [];
        // _pdfs: {
        //   [key: string]: {
        //     promise: Promise<NeoPdfDocument>
        //     pdf: NeoPdfDocument,
        //     fingerprint: string,
        //   }
        // } = {};
        this.dispatcher = new EventDispatcher();
        this.cancelJob = (id) => {
            const jobIdx = this._pdfs.findIndex((t) => t.taskId === id);
            if (jobIdx > -1) {
                const job = this._pdfs[jobIdx];
                job.refCount--;
                if (job.refCount < 1) {
                    const t = job;
                    t.canceled = true;
                    t.resolve = undefined;
                    delete this._pdfs[jobIdx];
                    this._pdfs.splice(jobIdx, 1);
                    t.reject(new Error(`pdf loader future job cancelled - ${t.taskId}, job remained=${this._pdfs.length}`));
                }
            }
        };
        // private getDocumentAsync = async (options: IPdfOpenOption) => {
        //   if (options.url && !options.fingerprint) {
        //     const pdfToLoad = new NeoPdfDocument();
        //     const promise = pdfToLoad.load(options);
        //     this._pdfs[options.url] = { promise, pdf: pdfToLoad, fingerprint: null }
        //     const pdfLoaded = await promise;
        //     this._pdfs[options.url].pdf = pdfLoaded;
        //     if (pdfLoaded) { // 로드가 안되는 경우도 있다. 2021/07/17
        //       this.dispatcher.dispatch(PdfManagerEventName.ON_PDF_LOADED, { pdf: pdfLoaded });
        //     }
        //     else {
        //       // 2021/07/17
        //       delete this._pdfs[options.url];
        //     }
        //     return pdfLoaded;
        //   }
        //   else {
        //     if (!options.fingerprint) {
        //       throw new Error(`PDF Manager: URL or fingerprint should be passed to load a document`);
        //     }
        //     // 이 부분을 수정할 것 (구글 드라이브에서 로드하려면)
        //     // google drive, 2020/12/05
        //     const status = await NeoPdfManager.getUrl(options);
        //     if (status.result === "success") {
        //       // const doc = new NeoPdfDocument();
        //       // return await doc.load({ url: status.url, filename: status.file.name, purpose: "to be opened from Google Drive by NeoPdfManager " });
        //     }
        //     if (status.result === "not match") {
        //       console.log("같은 파일이 아닙니다. 다시 여시겠습니까...라는 다이얼로그를 넣어서 루프를 돌 것");
        //       alert("같은 파일이 아닙니다. 다시 여시겠습니까...라는 다이얼로그를 넣어서 루프를 돌 것");
        //       return null as NeoPdfDocument;
        //     }
        //     return null as NeoPdfDocument;
        //   }
        // }
        this.getDocument = (options) => __awaiter(this, void 0, void 0, function* () {
            const t = this.requsetLoadDocument(options);
            const pdf = yield t.promise;
            return pdf;
        });
        // 2022/11/22
        this.requsetLoadDocument = (options) => {
            const { url, fingerprint, filename, forceReload } = options;
            // TODO: uniqueness가 보장되지 않는다. pdf file을 불러 올때부터, SOBP가 어디를 차지하고 있는지를 넣고
            // 중복되는 SOBP의 PDF는 불러오지 않도록 바꿔야 하겠다. 2021/08/04
            const uniqueKey = url;
            if (url && !fingerprint && !forceReload) {
                const t = this._pdfs.find((p) => uniqueKey === p.key);
                if (t) {
                    console.log(`PDF LOADING use previous PDF ==> ${filename}`);
                    t.refCount++;
                    return t;
                }
            }
            let resolve = undefined;
            let reject = undefined;
            const pr = new Promise((rsv, rjt) => {
                resolve = rsv;
                reject = rjt;
            });
            const taskId = uuidv4();
            console.log(`PDF LOADING start ==> ${filename}, taskId:${taskId}`);
            const task = {
                taskId,
                key: uniqueKey,
                promise: pr,
                refCount: 1,
                canceled: false,
                resolve,
                reject,
                cancel: () => {
                    const inst = NeoPdfManager.getInstance();
                    inst.cancelJob(taskId);
                },
                loaded: {
                    pdf: undefined,
                    fingerprint: undefined,
                }
            };
            let pdfToLoad = new NeoPdfDocument();
            pdfToLoad.load(options).then((pdf) => {
                const idx = this._pdfs.findIndex((p) => uniqueKey === p.key);
                if (idx > -1) {
                    // cancel 되지 않은 job 이라면
                    const t = this._pdfs[idx];
                    const { fingerprint } = pdf;
                    let returnPdf = pdf;
                    const sameFingerprintIdx = this._pdfs.findIndex((p) => { var _b, _c; return ((_c = (_b = p.loaded) === null || _b === void 0 ? void 0 : _b.pdf) === null || _c === void 0 ? void 0 : _c.fingerprint) === fingerprint; });
                    if (sameFingerprintIdx > -1) {
                        // 이전에 로드했던 PDF와 같은 PDF라면 새로 생성한 pdfToLoad를 폐기한다.
                        // this._pdfs[idx] = null;
                        // this._pdfs.splice(idx, 1);
                        const prevTask = this._pdfs[sameFingerprintIdx];
                        prevTask.refCount++;
                        returnPdf = prevTask.loaded.pdf;
                        t.loaded = { pdf: prevTask.loaded.pdf, fingerprint: prevTask.loaded.pdf.fingerprint };
                        pdfToLoad = undefined;
                        console.log(`PDF LAODING use cached PDF, numPDFs: ${this._pdfs.length}`);
                    }
                    else {
                        // 이전에 로드된 적 없는 것이라면 삭제하지 않는다.
                        console.log(`PDF LAODING append PDF to the cache, numPDFs: ${this._pdfs.length}`);
                        t.loaded = { pdf, fingerprint };
                    }
                    console.log(`PDF LAODING completed ${t.taskId}`);
                    if (!t.canceled && t.resolve) {
                        t.resolve(pdf);
                        this.dispatcher.dispatch(PdfManagerEventName.ON_PDF_LOADED, { pdf });
                    }
                }
            }).catch((e) => {
                throw new Error("NeoPdfManager load failed");
            });
            this._pdfs.push(task);
            return task;
        };
        this.addEventListener = (eventName, listener) => {
            this.dispatcher.on(eventName, listener, null);
        };
        /**
         *
         * @param eventName
         * @param listener
         */
        this.removeEventListener = (eventName, listener) => {
            this.dispatcher.off(eventName, listener);
        };
        if (_pdf_manager)
            return _pdf_manager;
    }
    static getInstance() {
        if (_pdf_manager)
            return _pdf_manager;
        _pdf_manager = new NeoPdfManager();
        // const msi = MappingStorage.getInstance();
        // msi.addEventListener(MappingStorageEventName.ON_MAPINFO_REFRESHED, _pdf_manager.refreshNcodeMappingTable);
        // msi.addEventListener(MappingStorageEventName.ON_MAPINFO_ADDED, _pdf_manager.handleMapInfoAdded);
        return _pdf_manager;
    }
    static get instance() {
        return NeoPdfManager.getInstance();
    }
}
_a = NeoPdfManager;
NeoPdfManager.getUrl = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const fingerprint = options.fingerprint;
    if (!fingerprint) {
        throw new Error(`PDF Manager: Fingerprint has not been passed`);
    }
    const result = yield openFileBrowser();
    console.log(result.result);
    if (result.result === "success") {
        const { url, file } = result;
        console.log(url);
        const isSame = NeoPdfManager.checkFingerprint({ url, filename: file.name, purpose: "to check fingerprint by NeoPdfManager" }, fingerprint);
        if (isSame)
            return { result: "success", url, file };
        return { result: "not match", url, file };
    }
    else {
        alert("파일 열기를 취소 했습니다");
        return { result: "canceled", url: null, file: null };
        // alert("파일 열기가 실패했습니다");
        // return { result: "failed", url: null };
    }
});
NeoPdfManager.checkFingerprint = (options, fingerprint) => __awaiter(void 0, void 0, void 0, function* () {
    let doc = new NeoPdfDocument();
    // await doc.load(options);
    const docFingerprint = doc.fingerprint;
    doc.destroy();
    doc = null;
    if (fingerprint !== docFingerprint)
        return false;
    return true;
});
//# sourceMappingURL=NeoPdfManager.js.map